import SimpleMessageComponent from '@/common-components/dialogs/simple-message-dialog.vue';
import { defineStore } from 'pinia';
import { markRaw, reactive, shallowReactive, shallowRef } from 'vue';
import {has as _has, get as _get} from 'lodash-es';
import {convertServersSpecialCharacters} from "@/common-scripts/utilities";
import LoadingOverlay from '@/common-components/dialogs/loading-overlay.vue'
import Snackbar from "@/common-components/dialogs/snackbar.vue";



export const useDialogManagerStore = defineStore('dialog-manager', {
	state: () => ({
		dialogConfigs: [],
		timeout: 3500
	}),
	actions: {
		removeAll(){
			this.dialogConfigs = [];
		},
		removeDialog(id){
			const index = this.dialogConfigs.findIndex(d => d.id == id);
			if(index != -1) this.dialogConfigs.splice(index, 1);
			else console.warn('removeDialog not found', id);
		},
		snackbar(text, action='success', settings={}) {
			const defaultSettings = {
				textAlign: 'center',	// left | center | right
				color: 'success',	// ['success', 'error', 'info', 'warning']
				location: 'top',	// top | bottom
				timeout: 2000
			};
			const props = {
				text: text,
				settings: {...defaultSettings, ...settings}
			};
			this.openDialog(Snackbar, props)
		},
		openDialog(dialogComponent, props, listeners){
			const dialogConfig = {
				id: Symbol('dialog'), // unique id
				component: dialogComponent,
				props: reactive(props),
				listeners
			}
			this.dialogConfigs.push(shallowReactive(dialogConfig));
	
			const removeDialog = () => {
				this.removeDialog(dialogConfig.id);
			}
	
			return {
				id: dialogConfig.id,
				removeDialog,
				updateDialog: (data) => {
					this.updateDialog(dialogConfig.id, data);
				},
				type: 'dialog'
			};
		},
		async openSimpleMessageDialog(props, autoCloseOnClick = true, dialogComponent = null){
			return new Promise((resolve, reject) => {
				let dialogData = null;
				const listeners = {
					clicked(result){
						resolve({
							result,
							dialogData
						});

						if(autoCloseOnClick && dialogData && typeof(dialogData.removeDialog) === 'function') dialogData.removeDialog();
					}
				}
				dialogData = this.openDialog((dialogComponent || SimpleMessageComponent), props, listeners);
			}).catch(e => {
				console.warn('openSimpleMessageDialog', e);
			});
		},
		/**
		 * 
		 * @param {Object|String} props if string is used a title
		 * @returns 
		 */
		showLoadingDialog(props){
			if(typeof(props) == 'string') props = {title: props};
			const data = this.openDialog(SimpleMessageComponent, Object.assign({
				loading: true,
				persistent: true,
				showOK: false
			}, props), {});
			return { close: data.removeDialog, update: data.updateDialog, type: 'loading' };
		},
		/**
		 * 
		 * @param {Object|String} props if string is used a title
		 * @returns 
		 */
		showLoadingOverlay(props){
			if(typeof(props) == 'string') props = {title: props};
			const data = this.openDialog(LoadingOverlay, Object.assign({}, props), {});
			return { close: data.removeDialog, update: data.updateDialog, type: 'loading' };
		},
		/**
		 * Allow to update properties to dialogs
		 * example updateDialog(id, {props: {text: "new text"}})
		 */
		updateDialog(id, data){
			const index = this.dialogConfigs.findIndex(d => d.id == id);
			if(index == -1) return;
			this.dialogConfigs[index] = Object.assign(this.dialogConfigs[index], {
				props: Object.assign(this.dialogConfigs[index].props, data.props)
			});
		},
		async showErrorDialogFromError(error, {title = null, message= null, messageHTML = null, showDetails= false, timeout = false, autoclose = true, showOK = true} = {}){
			if (!timeout) timeout = this.timeout;

			// const i18n = useI18n();
			// title = title || i18n.t('dialogs.warning');
			title = title || this.$i18n.t('dialogs.warning', 'Attenzione');
			if(!message && !messageHTML) {
				// const tmp = i18n.t('dialogs.errors.unexpected_error')
				// message = _get(error, 'message', tmp);
				message = _get(error, 'message', this.$i18n.t('dialogs.errors.unexpected_error'));
				if(showDetails && _has(error, 'response.data.details')){
					message = _get(error, 'response.data.details');
					message = convertServersSpecialCharacters(message[0].reason);
				} else if(_has(error, 'response.data.message')){
					message = _get(error, 'response.data.message');
				}
			}

			return await this.openSimpleMessageDialog({
				messageType: 'error',
				title: title,
				text: message,
				textHTML: messageHTML,
				showOK: showOK
			}, autoclose);
		},
		async showErrorReadingErrorDetails(error) {
			let message = this.$i18n.t('dialogs.errors.unexpected_error');
			// let message = this.$i18n.t('dialogs.errors.unexpected_error');
			if(_has(error, 'response.data.details')) {
				message = _get(error, 'response.data.details');
				message = convertServersSpecialCharacters(message[0].reason);
			}
			const d = await this.openSimpleMessageDialog({
				messageType: 'error',
				title: this.$i18n.t('dialogs.warning'),
				text: message,
				showOK: true,
			}, false);
			d.dialogData.removeDialog();
		}
	}
});